
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.231 21.487c.189.206.48.28.745.191l3.01-1.022 1.259 2.92c.11.256.363.423.642.424h.003c.279 0 .531-.164.644-.42l2.345-5.32a9.189 9.189 0 002.241 0l2.346 5.32c.113.256.365.42.644.42h.003a.703.703 0 00.642-.425l1.259-2.919 3.01 1.022a.703.703 0 00.87-.95l-2.641-5.984a9.094 9.094 0 001.888-5.556C21.14 4.122 17.04 0 12 0 6.96 0 2.86 4.122 2.86 9.188c0 2.088.704 4.015 1.887 5.556l-2.64 5.985a.703.703 0 00.124.758zm17.73-1.655l-2.11-.716a.703.703 0 00-.872.387l-.877 2.035-1.572-3.566a9.14 9.14 0 003.688-2.09l1.743 3.95zM4.265 9.188c0-4.291 3.47-7.782 7.735-7.782 4.265 0 7.734 3.491 7.734 7.782 0 4.264-3.47 7.734-7.734 7.734-4.265 0-7.735-3.47-7.735-7.734zm1.517 6.693a9.14 9.14 0 003.688 2.09l-1.572 3.566-.877-2.034a.703.703 0 00-.872-.387l-2.11.716 1.743-3.95z","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.238 10.085l-.411 2.397a.703.703 0 001.02.741L12 12.091l2.152 1.132a.703.703 0 001.02-.741l-.41-2.397 1.74-1.698a.703.703 0 00-.389-1.199l-2.406-.35-1.077-2.18a.703.703 0 00-1.26 0l-1.077 2.18-2.407.35a.703.703 0 00-.39 1.2l1.742 1.697zm1.623-1.908a.703.703 0 00.53-.385L12 6.558l.609 1.234c.102.208.3.352.53.385l1.362.198-.986.961a.703.703 0 00-.202.622l.233 1.357-1.22-.64a.703.703 0 00-.654 0l-1.218.64.232-1.357a.703.703 0 00-.202-.622l-.986-.961 1.363-.198z","fill":"#fff"}})])
          )
        }
      }
    